import React, { useState, useEffect } from 'react';
// import SectionMainImg from '../../../../assets/images/pages/Main/section1-main.webp'
import SectionMainImg from '../../../../assets/images/pages/Main/section1-main3.webp'

import SectionGlobeImg from '../../../../assets/images/pages/Main/section1-globe.webp'
import SectionAtomic from '../../../../assets/images/pages/Main/section1-atomic.webp'
import SectionBulb from '../../../../assets/images/pages/Main/section1-bulb.webp'
import SectionSpin1 from '../../../../assets/images/pages/Main/section1-spin1.webp'
import SectionSpin2 from '../../../../assets/images/pages/Main/section1-spin2.webp'
import SectionConf1 from '../../../../assets/images/pages/Main/section1-conf1.webp'
import SectionConf2 from '../../../../assets/images/pages/Main/section1-conf2.webp'
import Section1Img from '../../../../assets/images/pages/Main/section1-4.webp'
import Section2Img from '../../../../assets/images/pages/Main/section1-5.webp'
import BearIcon from '../../../../assets/images/pages/Main/bear-icon.svg'
import HouseIcon from '../../../../assets/images/pages/Main/house-icon.svg'
import ListIcon from '../../../../assets/images/pages/Main/list-icon.svg'
import BabyIcon from '../../../../assets/images/pages/Main/baby-icon.svg'
import ArmIcon from '../../../../assets/images/pages/Main/arm-icon.svg'
import LoveIcon from '../../../../assets/images/pages/Main/love-icon.svg'
import BrainIcon from '../../../../assets/images/pages/Main/brain-icon.svg'
import ArtIcon from '../../../../assets/images/pages/Main/art-icon.svg'
import SchoolIcon from '../../../../assets/images/pages/Main/school-icon.svg'
import { ActionButton } from './styles';
import Section3Img from '../../../../assets/images/pages/Main/section1-3.webp'
import { ConsultationFormModal } from '../../../popups/ConsulationPopup/ConsultationPopup';
import {Col, Flex, Row, Grid, Image} from "antd";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import { LANG_KEY, ROUTE_PATH } from "../../../../utils";
import styled from 'styled-components';
import {Cookies} from "react-cookie";
import { COOKIE_KEY } from '../../../../utils';
import { useDispatch } from 'react-redux';
import { selectStore } from '../../../../utils';
import { useSelector } from 'react-redux';
import {MyButton, MyImage, MyMotion, MyText} from "../../../common";
import {memo} from "react";
import MainSection1 from '../../../../assets/lottie/page/Main/section1.json'
import Lottie from "lottie-react";
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../utils';
import {WaveContainer} from "../WaveContainer";
import {useTranslation} from "react-i18next";
import { useLang } from '../../../../utils/context/lang';
import { fetchRegionsAction, fetchGetProfile, fetchKindergartensAction } from '../../../../utils';
import { useEmbeddedNavigate, useEmbeddedLink } from '../../../../utils/context/embed';
import { ArrowRightOutlined } from '@ant-design/icons';

const isMobile = window.innerWidth < 768;


const StyledCol = styled(Col)`
  @media (max-width: 1459px) {
    flex: 0 0 84.3333%;
    max-width: 84.3333%;
  }

  @media (min-width: 1903px) {
    flex: 0 0 45.6667%;
    max-width: 45.6667%;
  }
`;

const MainImage = memo(() => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();

  const isTablet = screens.md && !screens.xl && !screens.xxl;
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}>
    <div
      style={{
        backgroundColor: '#fff',
        border: `1px solid #FFF3E8`,
        borderRadius: 60,
        width: '100%',
        height: '80%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <img
        src={SectionMainImg}
        style={{
          // position: 'absolute',
          bottom: (isTablet || screens.xs) ? '0%' : '-35%',
          left: '50%',
          width: screens.xs ? '60%' : 'auto',
          // transform: (screens.xs || isTablet)  ? 'translateX(-50%)' : 'translateX(-50%) scale(0.7)',
        }}
      />
      <img
  src={SectionGlobeImg}
  style={{
    position: 'absolute',
    bottom: 0,
    right: 0,
    transform: screens.xs ? 'translate(15%, 20%)' : 'translate(40%, 20%)',
  }}
/>
      <img
        src={SectionAtomic}
        style={{
          position: 'absolute',
          top: '-10%',
          left: '-7%',
          width: '92px',
          height: '92px',
          transform: 'translate(10%, 10%)',
        }}
      />
      <img
        src={SectionBulb}
        style={{
          position: 'absolute',
          top: isTablet ? '60%' : '43%',
          left: screens.xs ? '22%' : isTablet ? '10%' : '15%',
          width: '55px',
          height: '55px',
          transform: screens.xs ? 'translate(-5%, -40%)' : 'translate(-30%, 10%)',
        }}
      />
      <img
        src={SectionSpin1}
        style={{
          position: 'absolute',
          top: '8%',
          left: screens.xs ? '78%' :'85%',
          width: screens.xs ? '35px' :'55px',
          height: screens.xs ? '35px' : '55px',
        }}
      />
      <img
        src={SectionSpin2}
        style={{
          position: 'absolute',
          bottom: '-5%',
          left: '5%',
          width: '85px',
          height: '85px',
          transform: 'translate(-30%, 10%)',
        }}
      />
      <img
        src={SectionConf1}
        style={{
          position: 'absolute',
          top: '-8%',
          left: '85%',
          width: '127px',
          height: '70px',
        }}
      />
      <img
        src={SectionConf2}
        style={{
          position: 'absolute',
          top: '15%',
          left: '-10%',
          width: '127px',
          height: '75px',
          
        }}
      />
    </div>
    </div>
  )
})

const ListItem = memo(({img, text, items, rangeKey}: any) => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [isHovered, setIsHovered] = useState(false);
const isTablet = screens.md && !screens.xl && !screens.xxl;


  return (
 <div
  style={{
    position: 'relative',
    backgroundColor: '#fff',
    border: '1px solid #FFF3E8',
    borderRadius: 30,
    padding: screens.xs || isTablet ? 14 : 32,
  }}
>
  <div
    style={{
      position: 'absolute',
      top: -35,
      left: '50%',
      transform: 'translateX(-50%)',
      width: screens.xs || isTablet ? '73%' : '40%',
      height: 35,
      background: 'rgba(24, 144, 255, 1)',
      borderRadius: '30px 30px 0 0',
      zIndex: 1,
    }}
  />

  <div
    style={{
      position: 'absolute',
      top: -35,
      left: '50%',
      transform: 'translateX(-50%)',
      width: screens.xs || isTablet ? '40%' : '16.1%',
      background: 'rgba(24, 144, 255, 1)',
      padding: screens.xs || isTablet ? '14px 0' : '20px 0',
      borderRadius: 25,
      zIndex: 3,
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <MyText
      color="#fff"
      size={screens.xs || isTablet ? 22 : screens.xxl ? 22 : 18}
      weight={800}
      style={{ fontFamily: 'Nunito', whiteSpace: 'nowrap' }}
    >
      {t(rangeKey)}
    </MyText>
  </div>

  <div
    style={{
      position: 'absolute',
      top: -35,
      left: screens.xs || isTablet ? '21.7%' : '35.6%',
      transform: 'translateX(-50%)',
      width: screens.xs || isTablet ? '17.7%' : '12.7%',
      height: screens.xs || isTablet ? '35.5px' : 35,
      background: 'rgb(232, 232, 232)',
      borderTopLeftRadius: 30,
      borderTopRightRadius: 30,
      zIndex: 4,
    }}
  />

  <div
    style={{
      position: 'absolute',
      top: -35,
      right: screens.xs || isTablet ? '21.7%' : '35.6%',
      transform: 'translateX(50%)',
      width: screens.xs || isTablet ? '17.7%' : '12.7%',
      height: screens.xs || isTablet ? '35.5px' : 35,
      background: 'rgb(232, 232, 232)',
      borderTopLeftRadius: 30,
      borderTopRightRadius: 30,
      zIndex: 4,
    }}
  />
      <Row
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        // }}
        // align='center'
        justify='center'
        gutter={screens.xs || isTablet ? 8 : 26}
      >
        <Col span={10}>
        
        <img src={img} alt={img} style={{height: isTablet ? 140 : (screens.xs ? 160 : 268), objectFit: 'contain'}}/>
        </Col>

        <StyledCol span={screens.xs || isTablet ? 24 : screens.xxl ? 12 : 14}>
          <Col span={24}>
    <MyText
      color={isHovered ? 'rgba(0, 189, 244, 1)' : '#0A033C'}
      size={
          screens.xs
            ? 18
            : isTablet
            ? 20
            : screens.xxl
            ? 28
            : 24
        }
      weight={800}
      style={{
        fontFamily: 'Nunito',
        lineHeight: screens.xs || isTablet ? "24px" : '48px',
        transition: 'color 0.3s ease',
        whiteSpace: 'pre-line',
      }}
    >
        {text.replace('(', '\n(')}
    </MyText>
</Col>
    <Col span={24} style={{padding: "0 !important", marginTop: 16}}>
      <Row gutter={[0,16]}>
        {items.map((item: any, i: number) => (
        <Col span={24}>
                        <Row align="middle">
                         <Col span={screens.xs || isTablet ? 6 : 4}>
                         <Image
                            src={item.icon}
                            preview={false}
                            width={42}
                            height={42}
                          />
                          </Col>
                          <Col span={screens.xs || isTablet ? 18 : 20}>
                        <MyText
                          color='#0A033C'
                          size={screens.xs || isTablet ? 18 : screens.xxl ? 18 : 16}
                          // lineHeight={screens.xs || isTablet ? '34px' : '24px'}
                          weight={700}
                          style={{
                            fontFamily: 'Nunito',
                          }}
                        >
                          {item.label}
                        </MyText>
                        </Col>
                        </Row>
        </Col>
        ))}
        <Col span={screens.xs || isTablet ? 22 : 19}>
        <ActionButton justify="center" align="middle" >
        <MyText
                          className="btn-text"
                          size={screens.xs || isTablet ? 18 : screens.xxl ? 18 : 16}
                          weight={500}
                          
                        >
                          {t("goToTasks")} <ArrowRightOutlined style={{ fontSize: 14, marginLeft: 8 }} />
                        </MyText>
          </ActionButton>
        </Col>
      </Row>
    
    </Col>
  </StyledCol>
      </Row>
    </div>
  )
})

export const Section1 = () => {
  const {t} = useTranslation("common")
  const { lang } = useLang();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [materials, setMaterials] = useState<any[]>([]);
  const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
  const dispatch = useDispatch();
  const {articles: {regions: regionsState}} = useSelector(selectStore)
  const cookies = new Cookies()
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const urlParams = new URLSearchParams(window.location.search);
  const eToken = urlParams.get('etoken'); 
  const navigate = useNavigate();
  const showModal = () => {
    setIsModalVisible(true);
    setCanSelectSpecialist(true);
  };

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => {
    setIsModalVisible(false);
    setCanSelectSpecialist(false);
  };
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [searchParams, setSearchParams] = useSearchParams();
  const { profile: { embedData: embedDataState}} = useSelector(selectStore);
  const { profile: { userData: userDataState, specialistsData: specialistsState}}: RootState = useSelector(selectStore);
  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  const themeParam = searchParams.get('embed');
  const location = useLocation();
  const search = location.search;
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();
  const isEmbed = urlParams.get('embed'); 
  
  useEffect(() => {
  dispatch(fetchGetProfile({
    onRegionNull: () => {
      embeddedNavigate('/register/confirm');
    }
  }));
}, []);

useEffect(() => {
  const regionId = userDataState?.data?.region_id;
  if (regionId) {
    dispatch(fetchKindergartensAction({ region_id: regionId }));
  }
}, [userDataState?.data?.region_id]);

  useEffect(() => {
    const fetchContent = async () => {
        try {
            // const response = await fetchMaterials(undefined);
            const response = await dispatch(fetchRegionsAction())
            const filteredMaterials = (response.tree || []).filter(item => item.type === "0");
            setMaterials(filteredMaterials);
        } catch (error) {
            console.error('Error fetching themes:', error);
        }
    };

    fetchContent();
}, []);

  const array = [
  {
    img: Section1Img,
    rangeKey: "youngAgeRange",
    items: [
      { icon: BabyIcon, label: t("firstWords") },
      { icon: ArmIcon, label: t("movementMotor") },
      { icon: LoveIcon, label: t("gamesWithMom") },
    ],
    text: t("youngAge1"),
    type: 'early',
    defaultType: '0-1',
  },
  {
    img: Section2Img,
    rangeKey: "preschoolAgeRange",
    items: [
      { icon: BrainIcon, label: t("logicThinking") },
      { icon: ArtIcon, label: t("creativity") },
      { icon: SchoolIcon, label: t("schoolPreparation") },
    ],
    text: t("preschoolAge1"),
    type: 'preschool',
    defaultType: '2-3'
  },
]

  return (
    <WaveContainer
      containerStyle={{
        backgroundColor: '#FCF8F1',
      }}
    >
      <Row justify="center" style={screens.xs ? {paddingTop: 0, marginBottom: '100px'}: {paddingTop: 64, paddingBottom: 64, zIndex: 2, position: 'relative'}}>
        <Col span={20}>
          <Row gutter={[80, 80]}>
            <Col span={24}>
              <Row gutter={[isTablet ? 40 : 22, 16]} style={screens.xs ? { display: 'flex', flexDirection: 'column' } : {display: 'flex',justifyContent: 'space-between' }}>
                <Col span={screens.xs || isTablet ? 24 : 16} style={screens.xs ? { maxWidth: '100%' } : {}}>
                  <Row gutter={[isTablet ? 20 : 0, isTablet ? 20 : 40]}>
                    <Col span={screens.xs || isTablet ? 24 : 22}>
                    <MyText
                      color='#080808'
                      size={screens.xs || isTablet ? 32 : 50}
                      lineHeight={screens.xs || isTablet ? '34px' : '64px'}
                      weight={800}
                      style={{
                        fontFamily: 'Nunito',
                      }}
                    >
                      {t("changingWorld")}
                    </MyText>
                    </Col>

                    <Col span={screens.xs || isTablet ? 24 : 20}>
                      <MyText size={22} lineHeight={screens.xs || isTablet ? '26px' : '32px'} color='#68727D'>
                        {t("sabiDamuDescription")}
                      </MyText>
                    </Col>
                    <Col span={screens.xs || isTablet ? 24 : 18}>
                      <Row gutter={screens.xxl ? [20,20] : [14,14]}>
                        <Col span={screens.xs || isTablet ? 24 : 8}>
                        <Row align="middle" justify='center' style={{background: 'white', borderRadius: 20, padding: 14}}>
                         <Col span={ screens.xs || isTablet ? 6 : 8}>
                         <Image
                            src={BearIcon}
                            preview={false}
                            width={42}
                            height={42}
                          />
                          </Col>
                          <Col span={ screens.xs || isTablet ? 18 : 16}>
                        <MyText
                          color='#0A033C'
                          size={screens.xs || isTablet ? 24 : screens.xxl ? 18 : 16}
                          // lineHeight={screens.xs || isTablet ? '34px' : '24px'}
                          weight={700}
                          style={{
                            fontFamily: 'Nunito',
                          }}
                        >
                          {t("forChildrenText")} <br /> {t("forChildrenRange")}
                        </MyText>
                        </Col>
                        </Row>
                        </Col>

                      <Col span={screens.xs || isTablet ? 24 : 8}>
                        <Row align="middle" justify='center' style={{background: 'white', borderRadius: 20, padding: 14}}>
                         <Col span={screens.xs || isTablet ? 6 : 8}>
                         <Image
                            src={HouseIcon}
                            preview={false}
                            width={42}
                            height={42}
                          />
                          </Col>
                          <Col span={screens.xs || isTablet ? 18 : 16}>
                        <MyText
                          color='#0A033C'
                          size={screens.xs || isTablet ? 24 : screens.xxl ? 18 : 16}
                          // lineHeight={screens.xs || isTablet ? '34px' : '24px'}
                          weight={700}
                          style={{
                            fontFamily: 'Nunito',
                          }}
                        >
                          {t("forHome")}
                        </MyText>
                        </Col>
                        </Row>
                        </Col>
                        
                        <Col span={screens.xs || isTablet ? 24 : 8}>
                        <Row align="middle" justify='center' style={{background: 'white', borderRadius: 20, padding: 14}}>
                         <Col span={screens.xs || isTablet ? 6 : 8}>
                         <Image
                            src={ListIcon}
                            preview={false}
                            width={42}
                            height={42}
                          />
                          </Col>
                          <Col span={screens.xs || isTablet ? 18 : 16}>
                        <MyText
                          color='#0A033C'
                          size={screens.xs || isTablet ? 24 : screens.xxl ? 18 : 16}
                          // lineHeight={screens.xs || isTablet ? '34px' : '24px'}
                          weight={700}
                          style={{
                            fontFamily: 'Nunito',
                          }}
                        >
                          {t("supportOOP")}
                        </MyText>
                        </Col>
                        </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <MyButton
                        color="orange"
                        type="primary"
                        style={screens.xs ? { width: '80%', height: '56px', fontSize: '20px' } : {}}
                        onClick={() =>
                          (isEmbed && eToken)
                            ? showModal()
                            : (
                                token
                                  ? showModal()
                                  : embeddedNavigate('/auth')
                              )
                        }
                      >
                        {t("specialistHelp")}
                      </MyButton>
                    </Col>

                    {/* <Col span={12}>
                      <MyButton
                        color="blue"
                        type="primary"
                        style={screens.xs ? { width: '80%', height: '56px', fontSize: '20px' } : {}}
                        onClick={() =>
                          (isEmbed && eToken)
                            ? showModal()
                            : (
                                token
                                  ? showModal()
                                  : embeddedNavigate('/auth')
                              )
                        }
                      >
                        Задать вопрос специалисту
                      </MyButton>
                    </Col> */}
                  </Row>
                </Col>

                {!screens.xs && (
                  <Col span={isTablet ? 8 : 8}>
                    <MainImage />
                  </Col>
                )}
              </Row>
            </Col>
            {screens.xs && (
              <Col span={24} style={{width: '280px', height:'280px'}}>
                <MainImage />
              </Col>
            )}
            {(embedDataState?.data) && (
              <Col span={20}>
              
  <Row gutter={[16, 16]} justify="start" wrap>
    <Col>
      <MyButton
        color="orange"
        type="primary"
        style={screens.xs ? { width: '160px', height: '56px', fontSize: '16px' } : {}}
        onClick={() => embeddedNavigate(ROUTE_PATH.SCREENING_TESTS_LIST)}
      >
        {t("selfDiagnosis")}
      </MyButton>
    </Col>
    <Col>
      <MyButton
        color="orange"
        type="primary"
        style={screens.xs ? { width: '160px', height: '56px', fontSize: '16px' } : {}}
        onClick={() => embeddedNavigate(ROUTE_PATH.SCREENING_WITH_SPECIALIST)}
      >
        {t("earlyDevelopmentScreening")}
      </MyButton>
    </Col>
    <Col>
      <MyButton
        color="orange"
        type="primary"
        style={screens.xs ? { width: '160px', height: '56px', fontSize: '16px' } : {}}
        onClick={() => embeddedNavigate(ROUTE_PATH.SCREENING_NEURO)}
      >
        {t("Neuropsychology")}
      </MyButton>
    </Col>
    <Col>
      <MyButton
        color="orange"
        type="primary"
        style={screens.xs ? { width: '160px', height: '56px', fontSize: '16px' } : {}}
        onClick={() => embeddedNavigate(ROUTE_PATH.ARTICLES)}
      >
        {t("articles")}
      </MyButton>
    </Col>
    <Col>
      <MyButton
        color="orange"
        type="primary"
        style={screens.xs ? { width: '160px', height: '56px', fontSize: '16px' } : {}}
        onClick={() => embeddedNavigate(ROUTE_PATH.TRAINING_CARDS)}
      >
        {t("trainingCards")}
      </MyButton>
    </Col>
  </Row>
  </Col>
)}
            <Col span={24} style={{zIndex: 1}}>
            <Row gutter={screens.xs ? [12, 48] : { xs: 8, sm: 16, md: 16, lg: 22, xl: 8, xxl: 21 }}>
                {array.map((item, index) => (
                  <Col span={screens.xs ? 24 : 12} key={index}>
                <Link
                  key={item.type}
                  to={embeddedLink(`/materials/${item.type}?id=${materials[index]?.id || ''}`)}
                >
                <ListItem img={item.img} text={item.text} items={item.items} rangeKey={item.rangeKey}/>
                      
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <div style={{
        position: 'absolute',
        transform: 'translate(0, -50%)',
        left: 0,
        right: 0,
        zIndex: 1
      }}>
        <Lottie animationData={MainSection1} loop={true}/>
      </div>
      <ConsultationFormModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} specialists={specialists} canSelectSpecialist={canSelectSpecialist}/>

    </WaveContainer>
  )
}